export { default as Properties } from './Properties'
